import {SectionType} from '../api/models';

export const isEmpty = (sampleString: string): boolean => {
    return sampleString.length === 0;
};

export const isNotEmpty = (sampleString: string): boolean => {
    return !isEmpty(sampleString);
};

export const buildStringFromSectionType = (sectionType: SectionType): string => {
    return sectionType
        .split('_')
        .map((e) => e.substring(0, 1).toUpperCase() + e.substring(1).toLowerCase())
        .join(' ');
};

export const generateId = (prefix: string, length: number) => {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
        counter += 1;
    }
    return prefix + '-' + result;
};

export const convertRupeeToString = (price: number): string => `Rs. ${price}`;

export const buildCartItemSubtitle = (price: number, qty: number): string => {
    const perItemPrice = convertRupeeToString(price);
    const totalPrice = convertRupeeToString(price * qty);

    return `${perItemPrice} * ${qty} = ${totalPrice}`;
};

export const stripSpecialCharsForWhatsappNumber = (str: string) => {
    return str.replace(/[^0-9]/g, '');
};

// validation functions

export const isNameValid = (customerName: string | undefined) => {
    if (customerName) {
        if (customerName.length > 3) {
            return true;
        }
    }
    return false;
};

export const isEmailValid = (customerEmail: string | undefined) => {
    if (customerEmail) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (emailRegex.test(customerEmail)) {
            return true;
        }
    }
    return false;
};

export const isAddressValid = (customerAddress: string | undefined) => {
    if (customerAddress) {
        if (customerAddress.length > 20) {
            return true;
        }
    }
    return false;
};

export const isMobileNumberValid = (customerMobileNumber: string | undefined) => {
    if (customerMobileNumber) {
        const mobileRegex = /^\+?\d{10}$/;
        if (mobileRegex.test(customerMobileNumber)) {
            return true;
        }
    }
    return false;
};

export const convertPaiseToRupees = (paise: number): string => {
    const rupees = paise / 100;
    return convertRupeeToString(parseFloat(rupees.toFixed(2)));
}
